import { render, staticRenderFns } from "./ApproveLayout.vue?vue&type=template&id=392bc43e&scoped=true"
import script from "./ApproveLayout.vue?vue&type=script&lang=js"
export * from "./ApproveLayout.vue?vue&type=script&lang=js"
import style0 from "./ApproveLayout.vue?vue&type=style&index=0&id=392bc43e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392bc43e",
  null
  
)

export default component.exports